import React , {useEffect, useRef,useState} from 'react'


import  {FloatingLabel,Form , Row , Col, Button ,  } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faMinus } from '@fortawesome/free-solid-svg-icons'
import ConfiguradorDesc from './ConfiguradorDesc';

var uniqid = require('uniqid'); // Generamos el uniqid

export default function ConfiguradorCuentas({index , erase , setValue }) {

    const refCampo = useRef() ;
    const refValores = useRef() ;

    const [stateNinguno,setStateNinguno] = useState( true )
    const [idTag,setIdTag] = useState( 0 ) ; // Ninguno

    

    var objValue = {
      uniqueid : index , // var uniqid = require('uniqid');
      tag : 0 , // [ "hoja" , 1 , { tag : 'hola'}]
      valores : ''
    }

    function onChangeValor(  )
    {
      
      //console.log( "Hola" ,  refValores.current )

      objValue.valores = refValores.current.value ;

      console.log( "onChangeValor "  , objValue )

      setValue( objValue )
    }

    function onChange( val)
    {

      console.log( "val = " + val )
      
      objValue.tag = val ;

      console.log( "Despues " , objValue )

      setValue( objValue ) ;
      
    }


    useEffect(() => {

      console.log( "ConfiguradorCuentas index useEffect " + index )

    } , [index])


    

    useEffect(() =>{

      console.log( "ConfiguradorCuestas = " + index )

    } ,[])



  return (
    <div className='mt-4'>

    <Row style={{marginLeft:'10px', marginRight:'10px'  }}>

        <Col className='col-6'>


        <div key={`inline-radio`} className="mb-3">
        <Form.Check
            inline
            label="Ninguno"
            name="group1"
            type='radio'
            id={`inline-radio-0`} 
            //value={stateNinguno}

            onChange={() => onChange(0)}
          />

          <Form.Check
            inline
            label="Descripcion"
            name="group1"
            type='radio'
            id={`inline-radio-1`} 
            onChange={() => onChange(1)}
          />
          <Form.Check
            inline
            label="NoIdentificacion"
            name="group1"
            type='radio' 
            id={`inline-radio-2`}
            onChange={() => onChange(2)}
          />

        </div>




        </Col>
        <Col className='col-5'>


            <FloatingLabel controlId="valores" label="Valores" >
                <Form.Control ref={refValores} type="text" onChange={onChangeValor}
                  placeholder="[Valores]" size='sm'  style={{ height: '10px' }} />
            </FloatingLabel>


        </Col>

        <Col className='col-1'>
        <FontAwesomeIcon  title='Eliminar Cuenta' onClick={() => erase(index)}
          icon={faMinus}></FontAwesomeIcon>
        </Col>




    </Row>

    <Row>
      <Col className='col-12'>
        <ConfiguradorDesc></ConfiguradorDesc>
      </Col>
           
    </Row>



    </div>
  )
}
